import { createReducer, createActions } from 'reduxsauce';

export const SIGNUP_STAGE = {
  EMAIL: 'email',
  CONTACT: 'contact'
};

const { Types, Creators } = createActions({
  initSocialSignup: ['token', 'contactInfo'],
  setSignupStep: ['step'],
  setSignupLoginInfo: ['loginInfo'],
  setSignupContactInfo: ['contactInfo']
});

export const SignupTypes = Types;
export default Creators;

/* ------- Initial State --------- */
export const INITIAL_STATE = {
  ssoToken: null,
  step: SIGNUP_STAGE.EMAIL,
  loginInfo: {
    email: '',
    password: '',
    passwordConfirmation: ''
  },
  contactInfo: {
    firstName: '',
    lastName: '',
    phoneNumber: ''
  },
  extraInfo: {
    optInNewsLetter: false,
    hasPets: false
  }
};

/* ------- Selectors --------- */
export const SignupSelectors = {
  selectCurrentStep: state => state.signup.step,
  selectLoginInfo: state => state.signup.loginInfo,
  selectContactInfo: state => state.signup.contactInfo,
  selectExtraInfo: state => state.signup.extraInfo,
  selectIsSignupFlow: state => state.signup.step !== SIGNUP_STAGE.EMAIL,
  selectSSOToken: state => state.signup.ssoToken
};

/* -------- Reducers ---------- */
export const setStep = (state, { step }) => {
  return {
    ...state,
    step
  };
};

export const setLoginInfo = (state, { loginInfo }) => {
  return {
    ...state,
    loginInfo
  };
};

export const setContactInfo = (state, { contactInfo }) => {
  return {
    ...state,
    contactInfo
  };
};

export const initSocialSignup = (state, { token, contactInfo }) => {
  const { email, ...rest } = contactInfo;
  return {
    ...state,
    loginInfo: {
      email,
      password: '',
      passwordConfirmation: ''
    },
    contactInfo: rest,
    step: SIGNUP_STAGE.CONTACT,
    ssoToken: token
  };
};

/* -------- Hookup Reducers to Types -------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.INIT_SOCIAL_SIGNUP]: initSocialSignup,
  [Types.SET_SIGNUP_LOGIN_INFO]: setLoginInfo,
  [Types.SET_SIGNUP_CONTACT_INFO]: setContactInfo,
  [Types.SET_SIGNUP_STEP]: setStep
});
